import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Navbar,
  Nav,
  Card,
  Badge,
  Image,
  Offcanvas,
} from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Navigate, useNavigate } from "react-router-dom";
import {
  FaWhatsapp,
  FaFilePdf,
  FaShippingFast,
  FaPlane,
  FaShip,
  FaRocket,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaUserPlus,
  FaShoppingCart,
  FaWarehouse,
  FaHome,
  FaGift,
  FaCheckCircle,
  FaExclamationTriangle,
  FaDollarSign,
  FaHeadset,
  FaInstagram,
  FaFacebook,
  FaTiktok,
  FaShareAlt,
  FaClock,
  FaBox,
  FaMapMarkedAlt,
  FaTag,
  FaCreditCard,
  FaTruck,
  FaBoxOpen,
  FaLock,
  FaSmile,
  FaCalendarAlt,
  FaArrowUp,
  FaArrowDown,
  FaChevronRight,
  FaTimes,
  FaPlayCircle,
  FaPlay,
  FaBoxes,
  FaPallet,
  FaPlaneDeparture,
} from "react-icons/fa";

import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import inicio from "../../assets/inicio.png";
import logoMbox from "../../assets/MBOX-LOGO-BLANCO.png";
import video1 from "../../assets/Video1.mp4";
import video2 from "../../assets/Video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";

import mboxitoMexico from "../../assets/mboxitoMexico.png";
import mboxitoEEUU from "../../assets/mboxitoEEUU.png";

import deliveryAnim from "../../assets/Animation - 1748224957909.json";
import mascota from "../../assets/MBOXITO_MASCOTA.png";
import trackingAnimation from "../../assets/Animation - 1747624631532.json";
import boxAnimation from "../../assets/Animation - 1747626198371.json";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";


const Navigation = (props) => {
  const [scrolled, setScrolled] = React.useState(false);
  const [activeLink, setActiveLink] = React.useState('inicio');
  React.useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      const sections = ['inicio', 'funciona', 'beneficios', 'tarifas', 'encomiendas', 'seguimiento', 'reempaque', 'contacto'];
      const scrollPosition = window.scrollY + window.innerHeight / 3;
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 50) {
        setActiveLink('contacto');
        return;
      }
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = sections[i];
        const element = document.getElementById(section);
        if (element && scrollPosition >= element.offsetTop) {
          setActiveLink(section);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id) => {
    setActiveLink(id);
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({ top: element.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
    }
  };
  return (
    <Navbar
        expand='lg'
        variant='dark'
        className={`fixed-top ${scrolled ? "navbar-scrolled" : ""}`}
        style={{
          backgroundColor: scrolled ? "rgba(24, 40, 72, 0.98)" : "#182848",
          transition: "all 0.3s ease",
          boxShadow: scrolled ? "0 2px 15px rgba(0,0,0,0.1)" : "none",
          height: "70px",
        }}
      >
        <Container>
          <Navbar.Brand
            href='https://mbox-hn.com'
            style={{
              fontWeight: 700,
              fontSize: "1.5rem",
              background: "linear-gradient(90deg, #FFFEF5 0%, #FFFFFD 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <img
              src={logoMbox}
              alt='Logo'
              width='40'
              height='40'
              style={{ objectFit: "contain" }}
            />
            Express
          </Navbar.Brand>
          <Navbar.Toggle aria-controls='basic-navbar-nav' />
          <Navbar.Collapse
            id='basic-navbar-nav'
            style={{
              backgroundColor: scrolled ? "rgba(24, 40, 72, 0.98)" : "#182848",
              borderRadius: "0 0 8px 8px",
            }}
          >
            <Nav className='ms-auto align-items-center'>
              <Nav.Link
                onClick={() => scrollTo("inicio")}
                className={`nav-link-custom ${
                  activeLink === "inicio" ? "active" : ""
                }`}
                style={{
                  fontWeight: activeLink === "inicio" ? "bold" : "normal",
                  color: activeLink === "inicio" ? "#F5A623" : "white",
                }}
              >
                Inicio
              </Nav.Link>
              <Nav.Link
                onClick={() => scrollTo("funciona")}
                className={`nav-link-custom ${
                  activeLink === "funciona" ? "active" : ""
                }`}
                style={{
                  fontWeight: activeLink === "funciona" ? "bold" : "normal",
                  color: activeLink === "funciona" ? "#F5A623" : "white",
                }}
              >
                ¿Cómo Funciona?
              </Nav.Link>

              <Nav.Link
                onClick={() => scrollTo("beneficios")}
                className={`nav-link-custom ${
                  activeLink === "beneficios" ? "active" : ""
                }`}
                style={{
                  fontWeight: activeLink === "beneficios" ? "bold" : "normal",
                  color: activeLink === "beneficios" ? "#F5A623" : "white",
                }}
              >
                Beneficios
              </Nav.Link>
              <Nav.Link
                onClick={() => scrollTo("tarifas")}
                className={`nav-link-custom ${
                  activeLink === "tarifas" ? "active" : ""
                }`}
                style={{
                  fontWeight: activeLink === "tarifas" ? "bold" : "normal",
                  color: activeLink === "tarifas" ? "#F5A623" : "white",
                }}
              >
                Tarifas
              </Nav.Link>
              <Nav.Link
                onClick={() => scrollTo("encomiendas")}
                className={`nav-link-custom ${
                  activeLink === "encomiendas" ? "active" : ""
                }`}
                style={{
                  fontWeight: activeLink === "encomiendas" ? "bold" : "normal",
                  color: activeLink === "encomiendas" ? "#F5A623" : "white",
                }}
              >
                Encomiendas
              </Nav.Link>
              <Nav.Link
                onClick={() => scrollTo("seguimiento")}
                className={`nav-link-custom ${
                  activeLink === "seguimiento" ? "active" : ""
                }`}
                style={{
                  fontWeight: activeLink === "seguimiento" ? "bold" : "normal",
                  color: activeLink === "seguimiento" ? "#F5A623" : "white",
                }}
              >
                Seguimiento
              </Nav.Link>

              <Nav.Link
                onClick={() => scrollTo("reempaque")}
                className={`nav-link-custom ${
                  activeLink === "reempaque" ? "active" : ""
                }`}
                style={{
                  fontWeight: activeLink === "reempaque" ? "bold" : "normal",
                  color: activeLink === "reempaque" ? "#F5A623" : "white",
                }}
              >
                Reempaque
              </Nav.Link>
              <Nav.Link
                onClick={() => scrollTo("contacto")}
                className={`nav-link-custom ${
                  activeLink === "contacto" ? "active" : ""
                }`}
                style={{
                  fontWeight: activeLink === "contacto" ? "bold" : "normal",
                  color: activeLink === "contacto" ? "#F5A623" : "white",
                }}
              >
                Contacto
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
  );
};

export default Navigation;
